export default "__VITE_ASSET__Dw7PYLhG__"